import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IUserDeviceState} from './user-device.reducer';
import {IDeviceOrientation, IDeviceOrientationAngle, IDeviceUserAgent} from '../models';
import {EDeviceOrientationEnum} from '../models/device-orientation.enum';

export const selectUserDeviceState = createFeatureSelector<IUserDeviceState>('user-device');

//#region USER DEVICE USER AGENT
export const selectDeviceUserAgent = createSelector(
  selectUserDeviceState,
  (state: IUserDeviceState): IDeviceUserAgent => state.userAgent,
);

export const selectIsDeviceUserAgentLoading = createSelector(
  selectDeviceUserAgent,
  (userAgent: IDeviceUserAgent): boolean => userAgent.isDeviceUserAgentLoading,
);

export const selectIsDeviceMobile = createSelector(
  selectDeviceUserAgent,
  (userAgent: IDeviceUserAgent): boolean => userAgent.isMobile,
);

//#endregion

//#region USER DEVICE ORIENTATION AND ANGLES
export const selectDeviceOrientation = createSelector(
  selectUserDeviceState,
  (state: IUserDeviceState): IDeviceOrientation => state.orientation,
);

export const selectIsUserDeviceOrientationLoading = createSelector(
  selectDeviceOrientation,
  (orientation: IDeviceOrientation): boolean => orientation.isDeviceOrientationLoading,
);

export const selectUserDeviceOrientation = createSelector(
  selectDeviceOrientation,
  (orientation: IDeviceOrientation): EDeviceOrientationEnum => orientation.orientation,
);

export const selectUserDeviceScreenAngle = createSelector(
  selectDeviceOrientation,
  (orientation: IDeviceOrientation): number => orientation.screenAngle,
);

export const selectUserDeviceAngles = createSelector(
  selectDeviceOrientation,
  (orientation: IDeviceOrientation): IDeviceOrientationAngle => orientation.deviceAngles,
);
//#endregion
